<template>
  <BaseVeeForm :action="updatePipeline" v-slot="{ isPending, isRejected, invalid }">
    <BaseCard>
      <BaseCardBody>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Pipeline name</h3>
          <p class="max-w-2xl text-sm text-gray-500">The pipeline's name</p>
        </div>
        <div class="mt-6 space-y-8">
          <ValidationProvider rules="required" name="name" tag="div" vid="name">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="name"> Pipeline name </BaseFormLabel>
                <BaseFormInput id="name" v-model="formData.name" />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider name="description" tag="div" vid="description">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="description"> Pipeline description </BaseFormLabel>
                <VTextEditor
                  :content="formData.description"
                  @change="formData.description = $event"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
      </BaseCardBody>
      <BaseCardFooter gray>
        <BaseButton primary :disabled="isPending || invalid || isRejected">
          Update pipeline
        </BaseButton>
      </BaseCardFooter>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
import { pick } from 'lodash-es';
import VTextEditor from 'Components/Common/VTextEditor.vue';

const props = {
  pipeline: {
    type: Object,
    default: () => ({}),
  },
};

function data() {
  return {
    formData: {
      ...pick(this.pipeline, ['name', 'description']),
    },
  };
}

const methods = {
  async updatePipeline() {
    try {
      await this.$store.dispatch('ui/pipelines/update', {
        pipelineUuid: this.pipeline.id,
        formData: this.formData,
      });

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  components: { VTextEditor },
  props,
  data,
  methods,
};
</script>
